/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const PASS_INV_VAL = 'boilderplate/FailedInvoice/PASS_INV_VAL'
export const RESET_FETCH_PASS = 'boilerplate/consolidateGet/RESET_FETCH_FAILED'
export const ON_NOTIFY = 'boilerplate/consolidateGet/ON_NOTIFY'
export const LOADER_STATUS = 'boilderplate/consolidateGet/LOADER_STATUS'
export const TOTAL_RECORD = 'boilerplate/consolidateGet/TOTAL_RECORD'
export const GET_ITEM = 'boilderplate/consolidateGet/GET_ITEM'
export const TOTAL_ITEM_RECORDS = 'boilderplate/consolidateGet/TOTAL_ITEM_RECORDS'
export const TXN_RECORD = 'boilerplate/consolidateGet/TXN_RECORD'
export const DISABLE_EDIT = 'boilderplate/consolidateGet/DISABLE_EDIT'
export const SET_PASS_PAGE = 'boilerplate/consolidateGet/SET_PASS_PAGE'
export const EXTEND_DATA = 'boilerplate/consolidateGet/EXTEND_DATA'
export const DISABLE_SELECT = 'biolerplate/consolidateGet/DISABLE_SELECT'